/*
Please note that for Japan region there is exclusive javasript file since in GLOWEB-2686 was requested special content. The scripts were separated because of errors on Tiny Slider and other functions. And also because of loading time.
*/

(function() {
	'use strict';
	var $ = avm.require('cash');
})();


var slider0 = tns({
	container: ".slider-pc",
	controlsContainer: ".slider-pc-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"controls": false,
	"navPosition": "bottom",
	"mouseDrag": true,
	"speed": 400,
	"fixedWidth": 304,
	"gutter": 32,
	"items": 1,
	"responsive": {
		"576": {
			"center": true
		},
		"768": {
			"items": 2,
			"slideBy": 2,
			"controls": true,
			"center": false
		},
		"1280": {
			"fixedWidth": 368
		}
	}
});
var slider1 = tns({
	container: ".slider-mac",
	controlsContainer: ".slider-mac-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"controls": false,
	"navPosition": "bottom",
	"mouseDrag": true,
	"speed": 400,
	"fixedWidth": 304,
	"gutter": 32,
	"items": 1,
	"responsive": {
		"576": {
			"center": true
		},
		"768": {
			"items": 2,
			"slideBy": 2,
			"controls": true,
			"center": false
		},
		"1280": {
			"fixedWidth": 368
		}
	}
});
var slider2 = tns({
	container: ".slider-android",
	controlsContainer: ".slider-android-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"controls": false,
	"navPosition": "bottom",
	"mouseDrag": true,
	"speed": 400,
	"fixedWidth": 304,
	"gutter": 32,
	"items": 1,
	"responsive": {
		"576": {
			"center": true
		},
		"768": {
			"items": 2,
			"slideBy": 2,
			"controls": true,
			"center": false
		},
		"1280": {
			"fixedWidth": 368
		}
	}
});
